import React from 'react';
import { Grid, FormControlLabel, Switch, Typography } from '@mui/material';
import { PaymentSettings } from '../../../../types/storeSettings';

interface PaymentMethodsSectionProps {
  formData: PaymentSettings;
  setFormData: React.Dispatch<React.SetStateAction<PaymentSettings>>;
  editing: boolean;
}

const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({
  formData,
  setFormData,
  editing
}) => {
  const handleTogglePaymentMethod = (method: 'enableCashOnDelivery' | 'enableBankTransfer' | 'enableElectronicPayment', checked: boolean) => {
    console.log(`Toggling ${method} to ${checked}`);
    setFormData(prev => ({
      ...prev,
      [method]: checked
    }));
  };

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom fontWeight="medium">
          طرق الدفع المتاحة
        </Typography>
      </Grid>
      
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.enableCashOnDelivery}
              onChange={(e) => handleTogglePaymentMethod('enableCashOnDelivery', e.target.checked)}
              name="enableCashOnDelivery"
              disabled={!editing}
              color="primary"
            />
          }
          label="الدفع عند الاستلام"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.enableBankTransfer}
              onChange={(e) => handleTogglePaymentMethod('enableBankTransfer', e.target.checked)}
              name="enableBankTransfer"
              disabled={!editing}
              color="primary"
            />
          }
          label="التحويل البنكي"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.enableElectronicPayment}
              onChange={(e) => handleTogglePaymentMethod('enableElectronicPayment', e.target.checked)}
              name="enableElectronicPayment"
              disabled={!editing}
              color="primary"
            />
          }
          label="الدفع الإلكتروني"
        />
      </Grid>
    </Grid>
  );
};

export default PaymentMethodsSection;
